import ItemModel from "../item-model";
import Project from "../../project/project";
import Task from "../../task/task";
import {EntityType} from "../../../gd/const/item";
import GanttItem from "../../../gd-modules/gantt-chart/model/gantt-item-new"
import TaskProgressSubItems from "../../task/task-view/helpers/progress-sub-items"
import {ItemDisplay, NumberOfChildren} from "../@type"

// Algorythm
// calculate(item)
// -- go over children
// -- children -> calculate(item)
// -- all children done
// -- -- update values

type Dictionary = {
    [key: string]: number;
}


// debug only
let counter = 0

type CalculatedFieldConfig = {
    itemModelFieldId    : string,
    itemFieldId?        : string,
    itemFunction?       : func
}

const calculatedFields : CalculatedFieldConfig[] = [
    {
        itemModelFieldId        : 'calculatedAttachments',
        itemFieldId             : 'attachmentsTotal' // i.e. task field
    },
    {
        itemModelFieldId        : 'reported',
        itemFieldId             : 'reportedTime'
    },
    {
        itemModelFieldId        : 'estimated',
        itemFieldId             : 'estimate'
    },
    {
        itemModelFieldId        : 'calculatedStoryPoints',
        itemFieldId             : 'storyPoints'
    },
    {
        itemModelFieldId        : 'costInternal',
        itemFieldId             : 'costInternal'
    },
    {
        itemModelFieldId        : 'costExternal',
        itemFieldId             : 'costExternal'
    },
    {
        itemModelFieldId        : 'estimatedCostInternal',
        itemFieldId             : 'estimatedCostInternal'
    },
    {
        itemModelFieldId        : 'estimatedCostExternal',
        itemFieldId             : 'estimatedCostExternal'
    },
    {
        itemModelFieldId        : 'calculatedExpenses',
        itemFunction            : (item:Task | Project) => {
            return item.expensesCollection?.total || 0
        }
    }

]



export default function listItem_UpdateCalculatedValues(listItem:ItemModel | GanttItem) {

    // console.log("->", listItem.debugName)

    const treeChildren = listItem.treeChildren as any[]

    // run for children first (recursevely)
    _.map(treeChildren, ((child: ItemModel)=>{
        listItem_UpdateCalculatedValues(child)
    }))

    const childrenTotals : Dictionary = {
        // fiesld    = children total value
    }



    // 1 calculate children totals

    // 1.1 set default to 0
    _.map(calculatedFields, (calculatedField)=>{
        childrenTotals[calculatedField.itemModelFieldId] = 0
    })

    //
    let resNumberOfChildren     : NumberOfChildren = {
        tasks               : 0,
        projects            : 0,
        projectsOpen        : 0,
        tasksOpen           : 0,
        tasksTotal          : 0,
        completedSubItems   : 0,

        projectTasksOpen    : listItem.isProject ? listItem.project.tasksOpen || 0 : 0,
        projectTasksTotal   : listItem.isProject ? listItem.project.tasksTotal || 0 : 0,

    }


    // 1.2 go over children to sum totals ?
    _.map(treeChildren, (child: ItemModel)=>{
        if (child.display !== ItemDisplay.VISIBLE) return

        _.map(calculatedFields, (calculatedField)=>{
            childrenTotals[calculatedField.itemModelFieldId] += child[calculatedField.itemModelFieldId as keyof ItemModel].total
        })

        // count children itself and later count its' grandchildren
        resNumberOfChildren.tasks               += (child.isTask && child.isNotHidden) ? 1 : 0

        // resNumberOfChildren.tasksOpen           += child.item.tasksOpen ? child.item.tasksOpen : 0
        // resNumberOfChildren.tasksTotal          += child.item.tasksTotal ? child.item.tasksTotal : 0
        resNumberOfChildren.tasksOpen           += (child.isTask && child.task.isOpen ) ? 1 : 0
        resNumberOfChildren.tasksTotal          += (child.isTask)? 1 : 0

        resNumberOfChildren.projects            += (child.isProject && child.isNotHidden) ? 1 : 0
        resNumberOfChildren.projectsOpen        += (child.isProject && child.isNotHidden && child.project.isOpen) ? 1 : 0
        resNumberOfChildren.completedSubItems   += (child.isClosed) ? 1 : 0 // ONLY for item itself no totals of grand parents

        // add child numChildren
        resNumberOfChildren.tasks               += child.numChildren.tasks
        resNumberOfChildren.tasksOpen           += child.numChildren.tasksOpen
        resNumberOfChildren.tasksTotal          += child.numChildren.tasksTotal
        resNumberOfChildren.projects            += child.numChildren.projects
        resNumberOfChildren.projectsOpen        += child.numChildren.projectsOpen

        resNumberOfChildren.projectTasksOpen    += (child.isProject) ? child.numChildren.projectTasksOpen : 0
        resNumberOfChildren.projectTasksTotal   += (child.isProject) ? child.numChildren.projectTasksTotal : 0


    })

    // 2 Set calculatedValue
    _.map(calculatedFields, (calculatedField)=>{
        // console.log("    ", calculatedField)

        // calc own value based on item.item
        let ownValue : number = 0
        if (calculatedField.itemFieldId) {
            // @ts-ignore
            ownValue = listItem.item[calculatedField.itemFieldId] || 0
        } else {
            // @ts-ignore
            ownValue = calculatedField.itemFunction(listItem.item)
        }
        // console.log("        own=", ownValue, "children=", childrenTotals[calculatedField.itemModelFieldId])

        // @ts-ignore
        listItem[calculatedField.itemModelFieldId] = {
            own:        ownValue,
            children:   childrenTotals[calculatedField.itemModelFieldId],
            total:      ownValue + childrenTotals[calculatedField.itemModelFieldId]
        }

    })

    // Number of children
    listItem.numChildren        =  resNumberOfChildren

    // mark as empty project - in future remove it as we can always check numChildren I guess
    // listItem.isEmptyProject = listItem.numChildren.tasks > 0
    listItem.isEmptyProject     = listItem.isProject &&
        listItem.numChildren.tasks < 1 &&
        listItem.numChildren.projectTasksTotal < 1 // pohodu eto ne children tasks a voobche vse pod pod pod

    // progressSubItems
    switch (listItem.type) {
        case EntityType.TASK:
            listItem.task.progressSubItems = new TaskProgressSubItems({
                progressSubItems: {
                    done    : listItem.numChildren.completedSubItems,
                    total   : listItem.treeChildren.length
                }
            })
            break
        case EntityType.PROJECT:

            // PORTFOLIO CASE
            if (listItem.project.tasksTotal && !_.isNil(listItem.project.tasksOpen)) {
                listItem.project.progressSubItems = new TaskProgressSubItems({
                    progressSubItems: {
                        done: listItem.project.tasksTotal - listItem.project.tasksOpen,
                        total: listItem.project.tasksTotal || 0
                    }
                })
            } else {
                // other cases...
                listItem.project.progressSubItems = {
                    done    : listItem.numChildren.completedSubItems,
                    total   : listItem.treeChildren.length
                }

                listItem.project.estimateTasks = listItem.estimated.children || 0

                if (listItem instanceof ItemModel) {
                    listItem.project.calculatedCostExternal = listItem.costExternal.children
                }
            }
            break

        case EntityType.EVENT:
        default:
            // nothing
            break
    }
    // if (listItem.isProject && listItem.project.tasksTotal && !_.isNil(listItem.project.tasksOpen)) {
    //     // this is Portfolio case
    //     listItem.project.progressSubItems = {
    //         done: listItem.project.tasksTotal - listItem.project.tasksOpen,
    //         total: listItem.project.tasksTotal || 0
    //     }
    // } else {
    //     // other cases...
    //     // seems like it never in use.... cant figure it out...
    //     listItem.item.progressSubItems = {
    //         done    : listItem.numChildren.completedSubItems,
    //         total   : listItem.treeChildren.length
    //     }
    // }


    // }


    // progressTasks
    if (listItem.isProject) {

        // Portfolio only
        if (!_.isNil(listItem.project.tasksOpen) && listItem.project.tasksTotal) {
            listItem.project.progressTasks =  gd.utils.roundToDecimals((listItem.project.tasksTotal! - listItem.project.tasksOpen)/listItem.project.tasksTotal * 100, 2)
        } else {
            // not Protfolio case
            if (listItem.numChildren.tasksTotal) {
                listItem.project.progressTasks =  gd.utils.roundToDecimals((listItem.numChildren.tasksTotal! - listItem.numChildren.tasksOpen)/listItem.numChildren.tasksTotal * 100, 2)
            } else {
                listItem.project.progressTasks = 0
            }

        }
    }

    // console.log("<-", listItem.debugName, "done()")



    // Calculate duration
    // DISABLED - now it's a getter calculated on request
    // However we can calculate it here in future if want to i.e. get _durationCalendar for example
    // END


    // // Number of children
    // listItem.numChildren = childrenValues.numChildren



    // console.log("-----")
    // console.log(listItem.getName())
    // console.log("Duration", listItem.item.duration)
    // console.log("Progress subItems", listItem.item.progressSubItems)
    // console.log("Reported time", listItem.reported)
    // console.log("numChildren = ", listItem.numChildren)
    // console.log("Estimate", listItem.estimated)
    // console.log("Labor Cost", listItem.costInternal)
    // console.log("Service Cost", listItem.costExternal)
    // console.log("Estimated Labor Cost", listItem.estimatedCostInternal)
    // console.log("Estimated Service Cost", listItem.estimatedCostExternal)
    // console.log("======")

    // debug only
    // console.log("calculate() called ", counter)



}
